import React from 'react'

function Header() {
  return (
    <>
      <header>
<span className='logoLike'>iknow779</span>
<ul>
  <li>About</li>
</ul>
</header>
<footer>
      
      <a href='https://www.twitter.com/iknow779' target="_blank" rel='noreferrer'><i class="fa-brands fa-twitter"></i></a>
      <a href='https://www.linkedin.com/in/iknow779' target="_blank" rel='noreferrer'><i class="fa-brands fa-linkedin"></i></a>
      <a href='https://www.t.me/iknow779' target="_blank" rel='noreferrer'><i class="fa-brands fa-telegram"></i></a>
      <a href='https://www.github.com/iknow779' target="_blank" rel='noreferrer'><i class="fa-brands fa-github"></i></a>
      
</footer>
    </>
  )
}

export default Header
